/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import { default as FinEscalationRoute } from 'embercom/routes/apps/app/automation/fin-ai-agent/escalation';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type ReportingUnderlyingDataService from 'embercom/services/reporting-underlying-data-service';
import { taskFor } from 'ember-concurrency-ts';
import type Store from '@ember-data/store';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';

export default class EscalationStandaloneRoute extends FinEscalationRoute {
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare reportingUnderlyingDataService: ReportingUnderlyingDataService;
  @service declare store: Store;
  @service declare knowledgeHubService: KnowledgeHubService;

  analytics = {
    section: 'standalone',
    place: 'standalone.escalation',
  };

  async beforeModel() {}

  async model() {
    let promises: Array<Promise<unknown>> = [
      this.store.findAll('ai-agent/guidelines'),
      this.store.findAll('ai-agent/escalation-rule'),
      taskFor(this.reportingMetrics.setup).perform(),
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation.fin.guidelines_applied.guideline_ids',
        'conversation',
        true,
      ),
    ];

    promises.push(
      taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
        'conversation.fin.escalation_rules_applied.escalation_rule_ids',
        'conversation',
        true,
      ),
    );

    this.knowledgeHubService.fetchKnowledgeUsageSummary();
    await Promise.all(promises);
    return super.model();
  }
}
